<div class="container">
  @if (isLoading()) {
    <ml-loader></ml-loader>
  }
  <pvmo-page id="page-edoc" [hidden]="!isUserConnected()"></pvmo-page>
</div>
